

declare let siteLocale;
import { Component, Vue, Prop, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import "./project-page.less";
import ProjectGalleries from "@/components/project-galleries/project-galleries.vue";
import ColorToneCard from "./color-tone.vue";

import {getNextReferenceUrl, getPreviousReferenceUrl, getProjectData} from "@/services/getProjectData/getProjectData";

@Component({
  components: {
    ProjectGalleries,
    ColorToneCard
  }
})
export default class ProjectPage extends Vue {
  private project: any = {};
  private navigations: { prev: string; next: string } = { prev: "", next: "" };
  private width = 0;

  public sortedProducts = [];

  mounted() {
    this.project = getProjectData();
    this.getWidth();
    this.navigations.prev = getPreviousReferenceUrl();
    this.navigations.next = getNextReferenceUrl();
    this.productsort(this.project.products);
    setTimeout(() => {
      this.updateLayout();
    }, 1000);
  }


  isExist(attributes: any) {
    if (
            typeof attributes == undefined ||
            attributes == null ||
            attributes == ""
    ) {
      return false;
    } else {
      return true;
    }
  }

  sortImages(images) {
    let sortedArray: any = [];
    $.each(images, function(index, element) {
      if (element.is_cover == 1) {
        sortedArray.unshift(element);
      } else {
        sortedArray.push(element);
      }
    });
    return sortedArray;
  }

  productsort(baseList){
    let self = this;
    if(siteLocale && siteLocale == 'hu'){
      let products = baseList.sort((prod1,prod2)=> {
        return self.getProductName(prod1).localeCompare(self.getProductName(prod2));
      });
      self.sortedProducts = products;
    }
    self.sortedProducts = baseList;
  }

  getProductName(product){
    if(siteLocale && siteLocale == 'int'){
      return product.epim_name;
    }
    return product.local_product ? product.local_product.name : product.name;
  }


  getWidth() {
    this.width = screen.width;
  }

  updateLayout() {
    var players = $('.lc-youtube');
    // console.log(players);
    players.each((i, p) => {
      let player = $(p);

      let screenX: number | undefined = player.parent().width();

      if (typeof screenX != "undefined") {
        //calc 16:9
        let screenY: number | undefined = (screenX / 16) * 9;

        //set palyer
        player.width(screenX);
        player.height(screenY);
      }
    });
  }

  getAttachmentName(source) {
    if (source != "") {
      source = source.split("/");
      return source[source.length - 1];
    } else {
      return "";
    }
  }

  trans(key) {
    return translate(key);
  }


}
